import { apiClient } from "../API/axiosInstance";

/**
 * Service class for billing operations
 */
export class BillingService {
  static async getCardCaptureSession() {
    const response = await apiClient.post(`/billing/card-capture-session`);
    return response.data["url"];
  }

  static async getBillingPortal() {
    const response = await apiClient.post(`/billing/portal`);
    return response.data["url"];
  }
}
